module.exports = __webpack_public_path__ + "img/login1.4cee8150.png";